
import _ from "lodash-es";
import dayjs from "dayjs";
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import {
  candidateDefaultColumns,
  HeaderColumn,
  HeaderShowType
} from "../config/list";
import Auth from "@/lib/common/auth";
import TimeUtil from "@/lib/common/time-util";
import vuexStore from "@/store/vuex-store";
import Loading from "@/components/loading.vue";
import AskGoOn from "@/components/ask-go-on.vue";
import TablePop from "@/components/table-pop.vue";
import EllipShow from "@/components/ellipShow.vue";
import TableSortDialog from "./tableSortDialog.vue";
import CandidateItemCom from "./candidateItem.vue";
import AddCandidateTags from "./add-candidate-tags.vue";
import EditCandidateRemark from "./edit-candidate-remark.vue";
import SendCandidateAsk from "./send-candidate-ask.vue";
import ReCandidateInterview from "./re-candidate-interview.vue";
import AsyncDownloadModal from "./async-download-modal.vue";
import {
  ExamList,
  ExamVersionSearch
} from "@/lib/model/exambuilder/exam-component/exam-list";
import {
  EnumAiRecommendStatus,
  EnumAuditStatus,
  EnumCandidateListSortKey,
  EnumMessageStatus,
  EnumProcessStatus,
  EnumSubmitStatus,
  CandidateItem,
  CandidateSearch,
  CandidateFeatures,
  CandidateList,
  EnumErrorInfoTask,
  EnumAutoSubmitType,
  CandidateExportPdfParam
} from "@/lib/model/exambuilder/exam-component/candidate";
import {
  Position,
  PositionGroup
} from "@/lib/model/exambuilder/exam-component/company";
import { CandidateNewResult } from "@/lib/model/exam/candidate-result";
import BatchFilterCandidate from "@/views/paper/components/batch-filter-candidate.vue";

//异常项
enum errorEnum {
  "livenessRecognition" = "候选人身份认证失败",
  "bgCheckIdentity" = "候选人手机号实名未通过",
  "bgCheckSocial" = "候选人存在社会安全风险",
  "bgCheckFinancial" = "候选人存在金融风险",
  "colorDetection" = "候选人辨色检测未通过",
  "handDetection" = "候选人手部检测未通过",
  "faceDetection" = "候选人脸部检测未通过",
  "replacementPerson" = "候选人面试过程中疑似换人",
  "faceShowDetection" = "候选人露脸检测未通过",
  "multiplePersonDetection" = "候选人面试过程中疑似多人",
  "screenshotDetection" = "候选人面试过程中多次截屏",
  "jumpOutDetection" = "候选人面试过程中多次切屏",
  "nameIdCheck" = "姓名或证件号与实际证件不匹配",
  "bodyDetection" = "候选人形体检测未通过",
  "keyboardSoundDetection" = "候选人面试过程中出现键盘声音"
}

interface SortMap {
  key: EnumCandidateListSortKey;
  dict: "ASC" | "DESC";
  label: string;
}

@Component({
  components: {
    AsyncDownloadModal,
    AskGoOn,
    Loading,
    EllipShow,
    TablePop,
    TableSortDialog,
    CandidateItemCom,
    AddCandidateTags,
    EditCandidateRemark,
    SendCandidateAsk,
    ReCandidateInterview,
    BatchFilterCandidate
  }
})
export default class CandidatesTable extends Vue {
  @Prop({ type: String, default: "all" })
  scene!: "exam" | "all";
  @Prop({ type: Number, default: 0 })
  examId!: number;
  @Prop({ type: Array, default: () => [] })
  headerParams!: string[];
  @Prop({ type: Array, default: () => [] })
  data!: CandidateItem[];
  @Prop({ type: Number, default: 0 })
  total!: number;
  @Prop({ type: Boolean, default: true })
  loading!: boolean;
  @Prop({ type: CandidateSearch, default: () => new CandidateSearch() })
  searchForm!: CandidateSearch;

  get EnumProcessStatus() {
    return EnumProcessStatus;
  }

  get HeaderShowType() {
    return HeaderShowType;
  }

  get storageKey() {
    let key = `${Auth.companyId}_${Auth.userId}_candidateListV3`;

    if (this.scene === "exam") {
      key += `_${this.examId}`;
    }
    const a = this.scene;
    const b = this.examId;

    return key;
  }

  // 交卷类型
  get submitType() {
    return {
      [EnumAutoSubmitType.Timeout]: "系统自动结束",
      [EnumAutoSubmitType.Screenshot]: "截屏触发强制交卷",
      [EnumAutoSubmitType.MobileJoinCount]: "切屏触发强制交卷",
      [EnumAutoSubmitType.Lr1]: "人脸核验匹配失败强制交卷",
      [EnumAutoSubmitType.Lr2]: "人脸核验超过最大次数强制交卷",
      [EnumAutoSubmitType.Expire]: "面试过期自动结束",
      [EnumAutoSubmitType.Repeat]: "系统新增邀请记录触发强制交卷",
      [EnumAutoSubmitType.NameIdCheck]: "姓名或证件号与实际证件不匹配强制交卷"
    };
  }

  // 批量筛选候选人：打开弹框
  showBatchFilter = false;
  onShowBatchFilter() {
    this.showBatchFilter = true;
  }

  connectCodeList: string[] = [];

  // 批量筛选候选人：确认
  handleBatchFilterConfirm(connectCodeList: string[] = []) {
    this.$message.success(`已提交${connectCodeList.length}条编码进行筛选`);
    this.searchForm.connectCodeList = connectCodeList;
    this.searchForm.page = 1;
    this.refresh();
  }

  // 批量筛选候选人：清空
  onClearConnectCodeList() {
    this.searchForm.connectCodeList = [];
    this.searchForm.page = 1;
    this.refresh();
  }

  // 购买报告
  candidateBuy(row: any) {
    const req = {
      candidateId: row.candidateId,
      companyId: row.companyId
    };
    CandidateItem.candidateBuy(req).then(resp => {
      if (resp.code === 0) {
        this.$message.success("购买成功");
        this.refresh();
      } else {
        this.$message.error("购买失败");
      }
    });
  }

  // 批次
  versionList: { value: number; label: string }[] = [];
  version = "";
  versionName = "";

  async getVersionList() {
    const params = new ExamVersionSearch().assign({ examId: this.examId });
    const res = await ExamList.getVersionList(params);

    if (res.code !== 0) return;

    this.versionList = res.data.list.map((item: any, index: number) => ({
      value: item.examVersionId,
      label: `批次${item.examVersionIndex + 1}`
    }));
    // this.getShowHeaderList(); //影响初次表头读取缓存了，且没看出来有必要重新获取
    this.$nextTick(() => this.initSelectInputStyle());
  }

  handleClearVersion() {
    this.versionName = "";
    this.searchForm.examVersionId = 0;
    this.searchForm.page = 1;
    this.refresh();
  }

  handleClickVersionOption(value: number, name: string) {
    if (this.searchForm.examVersionId === value) {
      this.version = "";
      this.versionName = "";
      this.searchForm.examVersionId = 0;
    } else {
      this.versionName = name;
      this.searchForm.examVersionId = value;
    }
    this.searchForm.page = 1;
    this.refresh();
  }

  // 胜任力评估结果
  aiRecommend = "";
  aiRecommendName = "";

  handleClearAiRecommend() {
    this.aiRecommendName = "";
    this.searchForm.aiRecommendStatusList = [];
    this.searchForm.page = 1;
    this.refresh();
  }

  handleClickAiRecommend(value: number, name: string) {
    if (this.searchForm.aiRecommendStatusList[0] === value) {
      this.aiRecommend = "";
      this.aiRecommendName = "";
      this.searchForm.aiRecommendStatusList = [];
    } else {
      this.aiRecommendName = name;
      this.searchForm.aiRecommendStatusList = [value];
    }
    this.searchForm.page = 1;
    this.refresh();
  }

  // 岗位
  positionList: PositionGroup[] = [];
  positionName = "";

  async getJobList() {
    const result = await Position.get();
    this.positionList = result.positionGroups;
  }

  visibleChange() {
    // 没有选择时默认展开第一个岗位分类
    const cascader = this.$refs.cascader as any;
    const panel = cascader?.$refs.panel;

    if (!panel) return;

    const node = panel.getNodeByValue([this.positionList[0].positionId]);
    panel.activePath = [node];
    panel.expandNodes([node]);
  }

  handleClearPosition() {
    this.positionName = "";
    this.searchForm.positionId = 0;
    this.searchForm.page = 1;
    this.refresh();
  }

  handleClickPositionOption() {
    const cascader = this.$refs.cascader as any;

    if (!cascader) return;

    const node = cascader.getCheckedNodes()?.[0];

    this.positionName = node?.label;
    this.searchForm.page = 1;
    this.refresh();
  }

  // 日期
  getOptions(key: string) {
    const today = dayjs(new Date()).format("YYYY-MM-DD");
    const todayStartTime = new Date(`${today} 00:00:00`).getTime();
    const endTime = new Date(`${today} 23:59:59`);

    return {
      shortcuts: [
        {
          text: "最近三天",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 3);
            picker.$emit("pick", [start, endTime]);
            this[key] = "最近三天";
            this.watchChange = false;
          }
        },
        {
          text: "最近一周",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, endTime]);
            this[key] = "最近一周";
            this.watchChange = false;
          }
        },
        {
          text: "最近两周",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 14);
            picker.$emit("pick", [start, endTime]);
            this[key] = "最近两周";
            this.watchChange = false;
          }
        },
        {
          text: "最近一个月",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, endTime]);
            this[key] = "最近一个月";
            this.watchChange = false;
          }
        }
      ]
    };
  }

  beginTimeMsg = "";
  createTimePickerOptions = this.getOptions("beginTimeMsg");

  submitTimeMsg = "";
  submitTimePickerOptions = this.getOptions("submitTimeMsg");

  // 是否触发监听以便修改input框中的展示内容
  watchChange = true;

  handleChangeDateSelector(value: string[], key: string) {
    this.searchForm.page = 1;
    this.refresh();

    if (!this.watchChange) return (this.watchChange = true);

    this[key] = value?.map(t => t.split(" ")[0]).join("～") || "";
  }

  // 标签
  tagList: string[] = [];
  tagNameMsg = "";
  tagSearch = "";
  searchTagsBeckUp: string[] = [];

  get filterTagList() {
    if (!this.tagSearch) return this.tagList;

    return this.tagList.filter(tag => tag.includes(this.tagSearch));
  }

  handleChangeTag(val: string[]) {
    this.tagNameMsg = val.join("，");
  }

  handleChangeTagVisible(res: boolean) {
    if (res) {
      this.searchTagsBeckUp = this.searchForm.tagNameList;
    } else {
      const change = !_.isEqual(
        this.searchTagsBeckUp,
        this.searchForm.tagNameList
      );

      if (change) {
        this.searchForm.page = 1;
        this.refresh();
      }
    }
  }

  // 排序
  sortMap: SortMap[] = [
    {
      key: EnumCandidateListSortKey.BeginTime,
      dict: "DESC",
      label: "按面试开始时间由近及远"
    },
    {
      key: EnumCandidateListSortKey.BeginTime,
      dict: "ASC",
      label: "按面试开始时间由远及近"
    },
    {
      key: EnumCandidateListSortKey.ScoreAi,
      dict: "ASC",
      label: "按AI评分从低到高"
    },
    {
      key: EnumCandidateListSortKey.ScoreAi,
      dict: "DESC",
      label: "按AI评分从高到低"
    }
  ];
  sort = "默认排序";

  handleClickSortOption(item: SortMap) {
    if (this.sort === item.label) {
      this.sort = "默认排序";
      this.searchForm.sortKey = "";
      this.searchForm.sortDict = "";
    } else {
      this.sort = item.label;
      this.searchForm.sortKey = item.key || "";
      this.searchForm.sortDict = item.dict || "";
    }

    this.refresh();
  }

  // 获取候选人筛选功能会用到的信息(全部面试的自定义登记信息并集、标签、岗位)
  async getListFeaturesList() {
    const res = await CandidateFeatures.get();

    this.tagList = res.tag;

    if (this.scene === "all") {
      this.paramList = res.paramName;
    }
  }

  // 表头相关
  paramList: string[] = [];
  hoverSelectAll = false;
  tableHeaderReady = true;
  showSortSetting = false;
  headerList: HeaderColumn[] = [];
  defaultHeaderList: HeaderColumn[] = [];
  showHeaderList: HeaderColumn[] = [];

  V = vuexStore;

  // 列表相关
  tableKey = 1;
  isWideList = false;

  @Watch("isWideList")
  handleChangeListStyle() {
    localStorage.setItem(
      `style_${this.storageKey}`,
      this.isWideList ? "wide" : "normal"
    );
  }

  // 自定义列更新
  @Watch("paramList", { deep: true })
  paramNameChange() {
    const headerListJSON = localStorage.getItem(this.storageKey);
    const a = this.storageKey;

    // 新生成表头
    if (!headerListJSON) return this.getShowHeaderList();

    try {
      const list = JSON.parse(headerListJSON);
      this.getShowHeaderList(list);
    } catch (err) {
      this.getShowHeaderList();
    }
  }

  // 获取表头显示的项
  getShowHeaderList(cacheData?: HeaderColumn[]) {
    // 过滤默认项
    const params = this.paramList
      .filter(param => {
        const isDefault = candidateDefaultColumns.some(
          item => item.label === param
        );
        return !["姓名", "手机"].includes(param) && !isDefault;
      })
      .map((param, index) => ({
        label: param,
        prop: param,
        required: false,
        isShow: false,
        draggable: true,
        showType: HeaderShowType.Param,
        minWidth: "200px",
        sort: candidateDefaultColumns.length + 1 + index
      }));

    this.defaultHeaderList = candidateDefaultColumns.concat(params);

    this.defaultHeaderList = this.defaultHeaderList.filter(item => {
      if (this.scene === "exam") {
        const map =
          this.versionList.length > 1
            ? ["positionName", "examName"]
            : ["positionName", "examName", "version"];

        return !map.includes(item.prop || "");
      }

      return !["version"].includes(item.prop || "");
    });

    this.headerList = cacheData ? cacheData : this.defaultHeaderList;
    this.showHeaderList = this.headerList.filter(item => item.isShow);
  }

  // 展示表头管理器
  showTableSetting() {
    this.showSortSetting = true;
    const selector = ".el-table__fixed-header-wrapper #setting-modal";
    const el = document.querySelector(selector);

    if (!el) return;

    const absoluteLeft = el.getBoundingClientRect().left;
    const absoluteTop = el.getBoundingClientRect().top;
    const showPosition = document.getElementById("show-setting-modal");

    if (!showPosition) return;

    showPosition.style.left = absoluteLeft + 24 - 240 + "px";
    showPosition.style.top = absoluteTop + 29 + "px";
    showPosition.style.position = "absolute";
  }

  // 保存排序后的更新列表
  refreshTable(headerList: HeaderColumn[]) {
    this.showSortSetting = false;
    this.tableHeaderReady = false;

    localStorage.setItem(this.storageKey, JSON.stringify(headerList));
    this.getShowHeaderList(headerList);

    this.$nextTick(() => {
      this.tableHeaderReady = true;
    });
  }

  checkAll = false;
  checkIdList: number[] = [];

  selectAllList(commandStr: string) {
    if (commandStr === "select-page") {
      this.checkAll = false;
      this.checkIdList = Array.from(
        new Set([
          ...this.checkIdList,
          ...this.data.map(item => item.candidateId)
        ])
      );
      this.data.forEach(item => {
        (this.$refs.multipleTable as any).toggleRowSelection(item, true);
      });
    }

    if (commandStr === "select-all") {
      this.checkAll = true;
      const preLength = (this.searchForm.page + 1) * this.searchForm.pageSize;
      const page = this.searchForm.page;
      this.searchForm.page = 1;

      CandidateList.getIdList(this.searchForm).then(res => {
        this.checkIdList = res.data.candidateIdList;

        // 如果当前页数据没在全选行列内，回第一页
        if (preLength > 4000) return this.refresh();

        this.searchForm.page = page;
        this.data.forEach(item => {
          (this.$refs.multipleTable as any).toggleRowSelection(item, true);
        });
      });
    }
  }

  handleCheckRow(selection: CandidateItem[], row: CandidateItem) {
    const index = this.checkIdList.findIndex(id => id === row.candidateId);

    if (index >= 0) {
      this.checkIdList.splice(index, 1);

      if (this.checkIdList.length === 0) {
        (this.$refs.multipleTable as any).clearSelection();
      }

      return;
    }

    if (this.checkIdList.length >= 4000) {
      this.$message.warning("最多选中4000条");
      return (this.$refs.multipleTable as any).toggleRowSelection(row, false);
    }

    this.checkIdList.push(row.candidateId);

    if (selection.length === 1) {
      this.selectedItem = selection[0];
    }
  }

  @Watch("data", { deep: true })
  handleDataChange() {
    this.data.forEach(item => {
      (this.$refs.multipleTable as any).toggleRowSelection(
        item,
        this.checkIdList.includes(item.candidateId)
      );
    });
  }

  handleClearSelected() {
    this.checkAll = false;
    this.checkIdList = [];
    (this.$refs.multipleTable as any).clearSelection();
  }

  // 列表内容
  formatTimeToday(time: string) {
    if (!time || time === "0001-01-01 00:00:00") return "-";

    return TimeUtil.formatTimeToday(time);
  }

  getStatusLabel(submitStatus: EnumSubmitStatus, target: "class" | "text") {
    const textMap = {
      [EnumSubmitStatus.EnumSubmitStatusNotSignIn]: "未登记",
      [EnumSubmitStatus.EnumSubmitStatusSignIn]: "已登记",
      [EnumSubmitStatus.EnumSubmitStatusAnswering]: "面试中"
    };

    const classMap = {
      [EnumSubmitStatus.EnumSubmitStatusNotSignIn]: "info",
      [EnumSubmitStatus.EnumSubmitStatusSignIn]: "info",
      [EnumSubmitStatus.EnumSubmitStatusAnswering]: "primary"
    };

    return target === "class"
      ? classMap[submitStatus] || "success"
      : textMap[submitStatus] || "面试完成";
  }

  scoreAiConvert(
    submitStatus: EnumSubmitStatus,
    scoreAi: number,
    aiProcessStatus: EnumProcessStatus
  ) {
    if (
      [
        EnumSubmitStatus.EnumSubmitStatusNotSignIn,
        EnumSubmitStatus.EnumSubmitStatusSignIn,
        EnumSubmitStatus.EnumSubmitStatusAnswering
      ].includes(submitStatus)
    ) {
      return "-";
    }

    if (
      [
        EnumSubmitStatus.EnumSubmitStatusFinish,
        EnumSubmitStatus.EnumSubmitStatusNoScore
      ].includes(submitStatus)
    ) {
      return aiProcessStatus === EnumProcessStatus.EnumProcessStatusFinish
        ? scoreAi
        : "正在打分";
    }
  }

  aiRecommendStatusConvert(
    aiRecommendStatus: EnumAiRecommendStatus,
    target: "class" | "text"
  ) {
    const textMap = {
      [EnumAiRecommendStatus.EnumAiRecommendStatusDefault]: "-",
      [EnumAiRecommendStatus.EnumAiRecommendStatusNotRecommend]: "不推荐",
      [EnumAiRecommendStatus.EnumAiRecommendStatusNormal]: "一般",
      [EnumAiRecommendStatus.EnumAiRecommendStatusRecommend]: "推荐",
      [EnumAiRecommendStatus.EnumAiRecommendStatusVeryRecommend]: "非常推荐"
    };

    const classMap = {
      [EnumAiRecommendStatus.EnumAiRecommendStatusDefault]: "",
      [EnumAiRecommendStatus.EnumAiRecommendStatusNotRecommend]: "warning",
      [EnumAiRecommendStatus.EnumAiRecommendStatusNormal]: "info",
      [EnumAiRecommendStatus.EnumAiRecommendStatusRecommend]: "primary",
      [EnumAiRecommendStatus.EnumAiRecommendStatusVeryRecommend]: "success"
    };

    return target === "class"
      ? classMap[aiRecommendStatus]
      : textMap[aiRecommendStatus];
  }

  auditStatusConvert(auditStatus: EnumAuditStatus, target: "class" | "text") {
    const textMap = {
      [EnumAuditStatus.EnumAuditStatusNoAudit]: "-",
      [EnumAuditStatus.EnumAuditStatusPass]: "通过",
      [EnumAuditStatus.EnumAuditStatusWait]: "待定",
      [EnumAuditStatus.EnumAuditStatusRefuse]: "拒绝"
    };

    const classMap = {
      [EnumAuditStatus.EnumAuditStatusNoAudit]: "",
      [EnumAuditStatus.EnumAuditStatusPass]: "success",
      [EnumAuditStatus.EnumAuditStatusWait]: "info",
      [EnumAuditStatus.EnumAuditStatusRefuse]: "danger"
    };

    return target === "class" ? classMap[auditStatus] : textMap[auditStatus];
  }

  messageStatusConvert(messageStatus: EnumMessageStatus) {
    switch (messageStatus) {
      case EnumMessageStatus.EnumMessageStatusOpenLink:
        return "公开邀请";
      case EnumMessageStatus.EnumMessageStatusNoSend:
        return "未通知";
      case EnumMessageStatus.EnumMessageStatusNoReply:
        return "已通知未打开";
      case EnumMessageStatus.EnumMessageStatusApply:
        return "已通知已打开";
    }
  }

  submitTypeConvert(item: CandidateItem) {
    if (
      [
        EnumSubmitStatus.EnumSubmitStatusNotSignIn,
        EnumSubmitStatus.EnumSubmitStatusSignIn,
        EnumSubmitStatus.EnumSubmitStatusAnswering
      ].includes(item.submitStatus)
    ) {
      return "-";
    }

    return item.isAutoSubmit !== 1
      ? "规定时间内正常完成"
      : this.submitType[item.autoSubmitType];
  }

  getParamValue(row: CandidateItem, columnName?: string) {
    return (
      row.paramList.find(item => item.name === columnName)?.cascadeValue || "-"
    );
  }

  getVersion(row: CandidateItem) {
    const el = this.versionList.find(
      version => version.value === row.examVersionId
    );
    return el ? el.label : "-";
  }

  // 异常提示弹窗
  errorText = "";
  showErrorInfo = false;

  showError(row: CandidateItem) {
    let t = ``;

    row.errorInfoList.forEach(item => {
      if (!errorEnum[item.task]) return;

      if (item.result !== 1) return;

      let errorMessage = errorEnum[item.task];

      if (item.task === EnumErrorInfoTask.EnumErrorInfoTaskFaceCheck) {
        errorMessage = item?.resMessage ? item.resMessage : errorMessage;
      }

      t += `${errorMessage || ""}<br/>`;
    });

    this.errorText = t;
    this.showErrorInfo = true;
  }

  // pdf报告页
  async candidatePdfReport(row: CandidateItem) {
    let previewUrl = `/r/report?connectCode=${row.connectCode}&companyId=${Auth.companyId}`;
    const result = await CandidateNewResult.getTid(row.candidateId);
    previewUrl += `&tid=${result.tid}&sid=${result.sid}`;
    await window.open(previewUrl);
  }

  // 报告页
  async candidateReport(row: CandidateItem) {
    // let previewUrl = `/candidate-info?connectCode=${row.connectCode}&companyId=${Auth.companyId}`;

    // //加密报告秘钥
    // await NR.getSid({
    //   companyId: Auth.companyId,
    //   candidateId: row.candidateId
    // }).then(res => {
    //   previewUrl += "&sid=" + res.sid;
    // });

    // window.open(previewUrl);
    let previewUrl = `/report-new-ai?connectCode=${row.connectCode}&companyId=${Auth.companyId}`;
    const result = await CandidateNewResult.getTid(row.candidateId);
    previewUrl += `&tid=${result.tid}&sid=${result.sid}`;
    await window.open(previewUrl);
  }

  // 评估页
  candidateEvaluate(row: CandidateItem) {
    CandidateList.getIdList(this.searchForm).then(res => {
      const searchForm: CandidateSearch = JSON.parse(
        JSON.stringify(this.searchForm)
      );
      searchForm.candidateIdList = res.data.candidateIds;

      if (searchForm.createdTime.length === 0) {
        searchForm.createdTime = ["1970-01-01 00:00:00", "2999-01-01 00:00:00"];
      }

      sessionStorage.setItem(
        "componentCandidateParams",
        JSON.stringify(searchForm)
      );
      const cid = Auth.companyId;

      const previewUrl = `/exam/mark?examId=${this.examId}&companyId=${cid}&auditStatus=${row.auditStatus}&connectCode=${row.connectCode}`;
      window.open(previewUrl);
    });
  }

  // 操作弹窗
  selectedIdList: number[] = [];
  selectedItem = new CandidateItem();
  editTagFlag = false;
  editRemarkFlag = false;
  sendInterviewFlag = false;
  sendResultFlag = false;
  reInterviewFlag = false;
  deleteFlag = false;
  mDeleteFlag = false;
  downloadFlag = false;

  addTagCallback() {
    this.refresh();
    this.editTagFlag = false;
    this.clear();
  }

  clear() {
    this.selectedIdList = [];
    this.selectedItem = new CandidateItem();
    this.handleClearSelected();
  }

  // 操作
  async operate({ flag, row }: { flag: string; row?: CandidateItem }, e?: any) {
    console.log("🚀 ~ CandidatesTable ~ operate ~ flag:", flag);
    if (e?.disabled) return;

    if (row) {
      this.selectedIdList = [row.candidateId];
      this.selectedItem = row;
    } else {
      this.selectedIdList = this.checkIdList;
    }

    switch (flag) {
      // 购买查看报告
      case "candidateBuyReport":
        this.candidateBuy(row);
        break;
      case "watchReport":
        if (row) {
          this.candidatePdfReport(row);
        }
        break;
      case "markCandidate":
        if (!row) return;
        this.candidateEvaluate(row);
        break;
      case "delete":
        this.deleteFlag = true;
        break;
      case "mDdelete":
        this.mDeleteFlag = true;
        break;
      case "export":
        this.exportCandidate();
        break;
      case "exportPdf":
        this.handleExportPdf();
        break;
      case "exportPdfWithVideo":
        this.handleExportPdf(true);
        break;
      case "oldReport":
        row && this.candidateReport(row);
        break;
      default:
        this[flag + "Flag"] = true;
    }
  }

  // 删除
  delSubmit() {
    if (this.selectedItem.candidateId > 0) {
      CandidateItem.delete(this.selectedItem.candidateId)
        .then(resp => {
          if (resp.code === 0) {
            this.$message.success("删除成功");
            this.refresh();
            this.del();
          } else {
            this.$message.error(resp.message);
          }
        })
        .then(() => {
          this.deleteFlag = false;
        });
    } else {
      this.$message.error("候选人不存在");
    }
  }

  mDelSubmit() {
    if (this.checkIdList.length > 0) {
      CandidateItem.mDelete(this.checkIdList)
        .then(resp => {
          if (resp.code === 0) {
            this.$message.success("删除成功");
            this.refresh();
            this.handleClearSelected();
            this.del();
          } else {
            this.$message.error(resp.message);
          }
        })
        .finally(() => {
          this.mDeleteFlag = false;
        });
    } else {
      this.$message.error("请选择需要删除的候选人");
    }
  }

  // 导出
  exportCandidate() {
    if (this.checkIdList.length <= 0) {
      this.$message.error("请选择要导出的候选人");
      return;
    }

    const searchForm: CandidateSearch = JSON.parse(
      JSON.stringify(this.searchForm)
    );

    searchForm.candidateIdList = this.checkIdList;

    CandidateList.export(searchForm).then(res => {
      if (res.code !== 0) return;

      this.downloadFlag = true;
    });
  }

  // PDF
  pdfNumber = 0;
  exportPdfWithVideo = false;
  pdfConfirmFlag = false;
  pdfDownloadFlag = false;

  handleExportPdf(withVideo = false) {
    if (this.checkIdList.length <= 0) {
      this.$message.error("请选择要导出的候选人");
      return;
    }

    this.exportPdfWithVideo = withVideo;

    const params = new CandidateSearch().assign({
      candidateIdList: this.checkIdList,
      onlyCount: true,
      afterReport: 1,
      returnAll: true
    });

    CandidateList.getList(params).then(res => {
      this.pdfNumber = res.count;
      this.pdfConfirmFlag = true;
    });
  }

  pdfExport() {
    const param = new CandidateExportPdfParam().assign({
      candidateIdList: this.checkIdList,
      needExportVideo: this.exportPdfWithVideo
    });

    CandidateList.exportPdf(param).then(res => {
      if (res.code !== 0) return;

      this.pdfConfirmFlag = false;
      this.pdfDownloadFlag = true;
    });
  }

  created() {
    this.getListFeaturesList();
    this.getJobList();

    if (this.scene === "exam") {
      this.paramList = this.headerParams;
      this.getVersionList();
    }

    // 不再使用宽列表
    // const listStyle = localStorage.getItem(`style_${this.storageKey}`);
    // this.isWideList = listStyle ? listStyle === "wide" : true;
  }

  @Emit()
  quickSearch(type: string, row: CandidateItem) {
    return { type, row };
  }

  @Emit()
  refresh() {
    return this.examId;
  }

  @Emit()
  del() {
    return this.examId;
  }

  // select 样式
  initSelectInputStyle() {
    const selectElList = document.querySelectorAll(".list-filter-item.select");
    selectElList.forEach(item => {
      const inner: any = item.querySelector(".el-input__inner");
      const prefix: any =
        item.querySelector(".el-input__prefix") ||
        item.querySelector(".prefix");
      const placeholder: any = item.querySelector(".placeholder");

      if (!inner || !prefix) return;

      inner.style.paddingLeft = `${prefix.offsetWidth + 18}px`;

      if (!placeholder) return;

      placeholder.style.paddingLeft = `${prefix.offsetWidth + 18}px`;
      placeholder.style.paddingRight = `62px`;
    });

    const timeElList = document.querySelectorAll(".list-filter-item.time");
    timeElList.forEach(item => {
      const date: any = item.querySelector(".el-date-editor");
      const placeholder: any = item.querySelector(".placeholder");

      if (!date || !placeholder) return;

      const pl = window.getComputedStyle(date, "before").width.slice(0, -2);

      placeholder.style.paddingLeft = `${Number(pl) + 18}px`;
      placeholder.style.paddingRight = `62px`;
    });
  }

  mounted() {
    this.initSelectInputStyle();
  }
}
